import React, { useState, useEffect } from 'react'
import Grid from '../components/Grid/Grid.js'
import NavBar from '../components/NavBar/NavBar.js'
import NavPane from '../components/NavPane/NavPane.js'
import { supabase } from '../supabaseClient'
import { useSelector } from 'react-redux'

const Recent = () => {
  const [videos, setVideos] = useState([])
  const [loading, setLoading] = useState(true)
  
  const isLogged = useSelector(state => state?.user?.isLoggedIn)
  const userState = useSelector(state => state?.user)

  // Get active username/user_id directly matching VideoPlayer and Liked logic
  const getUserId = () => {
    const u = userState?.user || userState?.userInfo || userState

    if (u?.username && u.username !== 'null') return String(u.username).trim()
    if (u?.user_id && u.user_id !== 'null') return String(u.user_id).trim()
    if (u?.id && u.id !== 'null') return String(u.id).trim()
    if (typeof u === 'string' && u !== 'null' && u !== '[object Object]') return u.trim()

    try {
      const stored = JSON.parse(localStorage.getItem('user'))
      if (stored?.username) return String(stored.username).trim()
      if (stored?.user_id) return String(stored.user_id).trim()
      if (stored?.id) return String(stored.id).trim()
    } catch (e) {}

    const directUser = localStorage.getItem('username') || localStorage.getItem('currentUser')
    return directUser ? String(directUser).trim() : null
  }

  const activeUser = getUserId()

  useEffect(() => {
    const fetchRecentVideos = async () => {
      setLoading(true)

      if (!activeUser) {
        console.warn("No logged in user found for Recent page.")
        setVideos([])
        setLoading(false)
        return
      }

      console.log("Fetching watched history for user:", activeUser)

      try {
        // 1. Get watched_videos array from user's profile (case-insensitive search)
        const { data: profiles, error: profileErr } = await supabase
          .from('profiles')
          .select('watched_videos')
          .ilike('user_id', activeUser)

        if (profileErr) console.error("Profile fetch error:", profileErr)

        const profile = profiles?.[0]
        const rawIds = profile?.watched_videos || []
        console.log("Raw watched_videos array from DB:", rawIds)

        if (!Array.isArray(rawIds) || rawIds.length === 0) {
          setVideos([])
          setLoading(false)
          return
        }

        // Prepare both numeric and string versions of IDs to support all primary key types
        const numericIds = rawIds.map(id => Number(id)).filter(id => !isNaN(id))
        const stringIds = rawIds.map(String)
        const queryIds = [...new Set([...numericIds, ...stringIds])]

        // 2. Query video details matching the IDs
        const { data: videoData, error: videoErr } = await supabase
          .from('videos')
          .select('*')
          .in('id', queryIds)

        if (videoErr) {
          console.error("Error fetching video details:", videoErr)
          setVideos([])
        } else {
          // Maintain recency order (most recently watched first)
          const sortedVideos = rawIds
            .map(id => (videoData || []).find(v => String(v.id) === String(id)))
            .filter(Boolean)

          console.log("Fetched sorted watched videos:", sortedVideos)
          setVideos(sortedVideos)
        }
      } catch (err) {
        console.error("Failed to load recent videos:", err)
      } finally {
        setLoading(false)
      }
    }

    fetchRecentVideos()
  }, [isLogged, activeUser])

  return (
    <div className="w-full h-full flex flex-col overflow-hidden">
      <NavBar activePage={"Recent"} />
      
      <div className="flex flex-row flex-1 pt-5 w-full h-full overflow-hidden">
        <NavPane activePage={"Recent"} />
        
        <div className="flex-1 p-4 overflow-y-auto">
          {loading ? (
            <div className="text-2xl font-semibold text-gray-600 w-fit relative top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
              LOADING DESUUUU...
            </div>
          ) : videos.length === 0 ? (
            <div className="text-2xl font-semibold text-gray-600 w-fit relative top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
              No watched videos
            </div>
          ) : (
            <Grid videos={videos} setVideos={setVideos} />
          )}
        </div>
      </div>
    </div>
  )
}

export default Recent
